import React from "react";
import { View } from "react-native";
import { TEXT_COLOR_ERROR } from "../../utils/Typography";
import { globalAny } from "../../utils/Utils";
import TextInput from "../../components/TextInput";
import ComponentThemeType from "../../models/ComponentTheme";
import Modal from "../../components/Modal";
import H4 from "../../components/Typography/H4";
import { AccountFormContentProps } from "./model";
import { Icon } from "../../Types";

const LazyDatePickerWidget = React.lazy(() => import("../../components/DatePickerWidget"));

const AccountFormContent = ({
	showDateModal,
	setShowDateModal,
	lastUsedDate,
	setLastUsedDate,
	form,
	setForm,
	email,
	onEnterEmail,
	secureTextEntry,
	onPressEye,
	onEnterPassword,
	birthday,
	setBirthday,
	formatDOB,
	isInCarScreen,
	birthdayPattern,
	errorSummary,
	hasValue,
}: AccountFormContentProps) => (
	<>
		{showDateModal && (
			<Modal onDismiss={() => setShowDateModal(false)}>
				<React.Suspense fallback="">
					<LazyDatePickerWidget
						lastUsedDate={lastUsedDate}
						onCancel={() => setShowDateModal(false)}
						onSubmit={(date) => {
							if (date) {
								setLastUsedDate(date);
								setForm({
									...form,
									year: { ...form.year, value: date.year() },
									month: { ...form.month, value: date.month() + 1 },
								});
							}
							setShowDateModal(false);
						}}
					/>
				</React.Suspense>
			</Modal>
		)}

		<TextInput
			componentTheme={ComponentThemeType.VinFast}
			label={globalAny.language.enter_email_ca}
			placeholder={globalAny.language.email_placeholder}
			error={!form.email.valid}
			errorMessage={form.email.errorMessage}
			onBlur={(e) => {
				const val = e.nativeEvent.text;
				setForm({ ...form, email: { ...form.email, value: val } });
				onEnterEmail(val);
			}}
			hasValue={hasValue(email)}
		/>

		<TextInput
			componentTheme={ComponentThemeType.VinFast}
			passwordField={secureTextEntry}
			label={globalAny.language.enter_password}
			onPressInputIcon={onPressEye}
			inputIcon={secureTextEntry ? Icon.eye : Icon.eyeOff}
			error={!form.password.valid}
			errorMessage={form.password.errorMessage}
			onBlur={(e) => {
				const val = e.nativeEvent.text;
				setForm({ ...form, password: { ...form.password, value: val } });
				onEnterPassword(val);
			}}
			hasValue={hasValue(form.password.value)}
		/>

		<TextInput
			value={birthday}
			keyboardType="numeric"
			componentTheme={ComponentThemeType.VinFast}
			label={globalAny.language.date_of_birth}
			placeholder="YYYY / MM"
			error={!form.birthday.valid}
			errorMessage={form.birthday.errorMessage}
			onChangeText={(date) => {
				if (date.length > 7 || isInCarScreen()) return;
				if (!birthdayPattern.test(date) && date.length > 0) return;
				setBirthday(date);
				formatDOB(date);
			}}
			onChange={(e) => {
				const date = e.nativeEvent.text;
				if (date.length > 7 || !isInCarScreen()) return;
				if (!birthdayPattern.test(date) && date.length > 0) return;
				setBirthday(date);
				formatDOB(date);
			}}
			onSubmitEditing={(e) => {
				if (!isInCarScreen()) return;
				formatDOB(e.nativeEvent.text);
			}}
			onEndEditing={(e) => {
				if (!isInCarScreen()) return;
				formatDOB(e.nativeEvent.text);
			}}
			onBlur={() => {
				if (!isInCarScreen()) return;
				formatDOB(birthday);
			}}
			hasValue={hasValue(birthday)}
		/>

		{Boolean(errorSummary) && (
			<View>
				<H4 fontColor={TEXT_COLOR_ERROR}>{errorSummary}</H4>
			</View>
		)}
	</>
);

export default AccountFormContent;
